export default {"src":"/_next/static/media/faqs-circular.4ef993e1.svg","height":138,"width":138,"blurWidth":0,"blurHeight":0};